import React, { useState, useEffect, useRef } from "react";
import "../../../assets/scss/components/templates/customSelect.scss";

import selectedOptionIcon from "../../../assets/images/library/selected-option.svg";
import dropdownArrow from "../../../assets/images/library/dropdown-arrow.svg";
import { Image } from "react-bootstrap";

import region from "../../../assets/images/library/region.svg";

const RegionSelect = ({
  options,
  defaultOption,
  onSelect,
  skillOptions,
  skillOptionsList,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div
      className={`custom-select region-select ${disabled ? "disabled" : ""}`}
      ref={selectRef}
    >
      <img className="select-arrow-icon" src={dropdownArrow} />
      <div
        className="selected-option"
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <Image src={region} className="me-2" />
        Region: <span className="ms-1">{selectedOption}</span>
      </div>
      {isOpen && (
        <ul className={`options-list ${skillOptionsList}`}>
          {options.map((option, index) => (
            <div className={`${skillOptions}`}>
              <li
                key={index}
                className={`option-item ${
                  selectedOption === option ? "selected" : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                {option}
                {selectedOption === option ? (
                  <Image src={selectedOptionIcon} />
                ) : (
                  ""
                )}
              </li>
            </div>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RegionSelect;
